import { render, staticRenderFns } from "./RegistroItemDialogComponent.vue?vue&type=template&id=66143dbc"
import script from "./RegistroItemDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroItemDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports